import { Check } from 'lucide-react';
import { STEPS } from './types';

interface StepIndicatorProps {
  currentIndex: number;
  completedSteps: Set<number>;
}

export default function StepIndicator({ currentIndex, completedSteps }: StepIndicatorProps) {
  return (
    <div className="flex items-center justify-between mb-8">
      {STEPS.map((step, index) => {
        const isCompleted = completedSteps.has(index);
        const isCurrent = index === currentIndex;
        const isPast = index < currentIndex;

        return (
          <div key={step.key} className="flex items-center flex-1">
            <div className="flex flex-col items-center">
              <div
                className={`
                  w-10 h-10 rounded-full flex items-center justify-center border-2 transition-colors
                  ${isCompleted ? 'bg-primary border-primary text-primary-foreground' : ''}
                  ${isCurrent && !isCompleted ? 'border-primary text-primary bg-primary/10' : ''}
                  ${!isCurrent && !isCompleted ? 'border-muted-foreground/30 text-muted-foreground' : ''}
                `}
              >
                {isCompleted ? <Check className="h-5 w-5" /> : step.icon}
              </div>
              <span
                className={`
                  mt-2 text-xs font-medium
                  ${isCurrent ? 'text-primary' : 'text-muted-foreground'}
                `}
              >
                {step.label}
              </span>
            </div>
            {index < STEPS.length - 1 && (
              <div
                className={`
                  flex-1 h-0.5 mx-2 mt-[-20px]
                  ${isPast || isCompleted ? 'bg-primary' : 'bg-muted-foreground/30'}
                `}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
